<template>
  <el-drawer
    title="预览"
    :visible.sync="drawerVisible"
    direction="rtl"
    size="600px"
    custom-class="preview-drawer"
    @close="$emit('close')"
  >
    <div class="content">
      <div class="detail-box" v-loading="loading">
        <img :src="data.informationUrl" alt />
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { getInformation } from '@/api/carousel';

export default {
  name: 'carouselPage',
  data() {
    return {
      data: {},
      shopList: [],
      drawerVisible: false,
      loading: false,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectId: {
      type: Number,
      required: true,
    },
  },
  watch: {
    visible(value) {
      this.drawerVisible = value;
    },
    selectId(value) {
      this.handleShow(value);
    },
  },
  methods: {
    getInformation(id) {
      return getInformation(id).then((res) => {
        if (res.success) {
          this.data = res.data;
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    async handleShow(id) {
      this.loading = true;
      await this.getInformation(id).catch(() => {});
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/h5.styl'
.content
  overflow hidden
  .detail-box
    display flex
    align-items center
    padding 0 !important
  >>>img
    width 100% !important
    height 619px !important
</style>
